import { skipInitialFormValues } from "@/utils/formUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validationConstants, validations } from "@/utils/validationUtils";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../../common/components/icons/AntIcon";
import { rowGutter } from "../../../../common/constants";
import { TopAgentSelect } from "../../../enumerations/components/form/TopAgentSelect";
import { DEFAULT_FILTER_CONFIG_PROPERTIES_QUERY_PARAMS } from "../../api";
import { DynamicConfigPropertyFilterPageRequest } from "../../types";

const colSpan = 6;

interface Props {
  searchParams: DynamicConfigPropertyFilterPageRequest;
  onCreateClick: () => void;
}

export const ConfigPropertyFilterView = ({ searchParams, onCreateClick }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<DynamicConfigPropertyFilterPageRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [searchParams, form]);

  const onFilterSubmit = (values: DynamicConfigPropertyFilterPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            ...values,
            ...skipInitialFormValues(values, DEFAULT_FILTER_CONFIG_PROPERTIES_QUERY_PARAMS),
            pageIndex: undefined,
          },
        }),
      },
      { replace: true },
    );
  };

  return (
    <Card
      className="card-box"
      title={<h2>{t("configProperty.titles.list")}</h2>}
      extra={
        <Button type="primary" icon={<AntIcon type="plus" />} onClick={onCreateClick}>
          {t("configProperty.actions.createProperty")}
        </Button>
      }
    >
      <Form form={form} onFinish={onFilterSubmit} layout="vertical" name="configPropertySearchViewForm">
        <Row gutter={rowGutter} justify="center">
          <Col span={colSpan}>
            <Form.Item
              name="keyword"
              label={t("common.search")}
              rules={[
                validations.size(
                  validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
                  validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
                ),
              ]}
            >
              <Input allowClear placeholder={t("configProperty.helpers.propertySearchHint")} />
            </Form.Item>
          </Col>

          <Col span={colSpan}>
            <TopAgentSelect
              formItemProps={{
                name: "ownedByIds",
                label: t("configProperty.attrs.ownedById"),
                rules: [validations.none],
              }}
              selectProps={{
                mode: "multiple",
                maxTagCount: "responsive",
                allowClear: true,
              }}
            />
          </Col>

          <Col flex="110px" className="no-title-space">
            <Form.Item>
              <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
                {t("common.filter")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
